/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CampTripDto } from '../../models/camp-trip-dto';
import { CampTripShowResponse } from '../../models/camp-trip-show-response';

export interface PostCampTripCreate$Params {
      body: CampTripDto
}

export function postCampTripCreate(http: HttpClient, rootUrl: string, params: PostCampTripCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<CampTripShowResponse>> {
  const rb = new RequestBuilder(rootUrl, postCampTripCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CampTripShowResponse>;
    })
  );
}

postCampTripCreate.PATH = '/v1/camp-trip';
